import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface ApplyOCClaimRecoveryPercentParams {
  fbOcKey: number;
  percentage: number;
}

export const applyOCClaimRecoveryPercentAPI = (params: ApplyOCClaimRecoveryPercentParams) => {
  return axiosInstance.request({
    data: {
      fbOcKey: params.fbOcKey,
      percentage: params.percentage,
    },
    method: 'post',
    url: `${API.OVERCHARGE_CLAIM}/ApplyClaimRecovery`,
  });
};

export const applyOCClaimRecoveryPercent = async (params: ApplyOCClaimRecoveryPercentParams) => {
  const response: AxiosResponse = await applyOCClaimRecoveryPercentAPI(params);
  return response.data;
};
